import { api } from "../api/client";
import type { AskOut, AskScopeBody, AskSettingsOut } from "../api/types";

/** The server keeps no history (F11 privacy): each call is one stateless question. */
export function askMeetings(orgId: string, question: string, scope?: AskScopeBody): Promise<AskOut> {
  return api<AskOut>("POST", `/orgs/${orgId}/ask`, scope ? { question, scope } : { question });
}

export function getAskSettings(orgId: string): Promise<AskSettingsOut> {
  return api<AskSettingsOut>("GET", `/orgs/${orgId}/ask/settings`);
}

export function putAskSettings(orgId: string, body: Partial<AskSettingsOut>): Promise<AskSettingsOut> {
  return api<AskSettingsOut>("PUT", `/orgs/${orgId}/ask/settings`, body);
}
